<rds-form-field labelPosition="top">
  <rds-control-label>{{ config.label }}</rds-control-label>
  <rds-autocomplete
    [ngModel]="user"
    [options]="data"
    [disabled]="disabled"
    [placeholder]="config.placeholder"
    [minSearchChars]="minSearchChars"
    [displayProperty]="displayProperty"
    [uniqProperty]="uniqProperty"
    (ngModelChange)="onInputChange($event)"
    (blur)="propagateTouched()"></rds-autocomplete>
</rds-form-field>
